import { memo, useEffect, useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  Card,
  TextField,
  Typography,
  Grid,
  Box,
  Button,
  IconButton,
  Divider,
  FormControl,
  InputLabel,
  FormHelperText,
  Select,
  MenuItem,
  Chip,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Modal,
  Radio,
} from "@mui/material";
import { VscCloudUpload } from 'react-icons/vsc';
import { useDropzone } from 'react-dropzone';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Close } from "@mui/icons-material";
import { useNavigate, } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useTMutation } from "../../../../../utils/useTMutation";
import showToast from "../../../../../components/Hot-Toast/showToast";
import { previousStep } from "../../../../../slice/multiStepSlice";
import { fetchJobRoles } from "../../../../../utils/commonAPI";
import { useTQuery } from "../../../../../utils/useTQuery";
import axios from "axios";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CloseIcon from "@mui/icons-material/Close";
import { getStringAfterLastSlash } from "../../../../../utils/genericMethod";
import { API_URL, FRONTEND_URL } from "../../../../../appConstants";
import PdfEditorAdmin from "./PdfEditorAdmin";
import style from "./addOnboardingDocument.css"; // Do not remove
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
export const jobRoleSchema = z
  .object({
    DOCUMENT_NAME: z.string().min(1, { message: "Document Name is required" }),
    REQUIREMENT: z.string().min(1, { message: "Requirement is required" }),
    JOBROLE_ID: z.array(z.string()).optional(), // Make JOBROLE_ID optional
    DOCUMENT_STATUS: z.string().min(1, { message: "Status is required" }),
    DOCUMENT_DESCRIPION: z
      .string()
      .min(1, { message: "Description is required" }),
    // IS_ALL_JOBROLE: z.boolean().optional(),
  })
// .refine(
//   (data) => {
//     if (data.IS_ALL_JOBROLE) {

//       return true; // If IS_ALL_JOBROLE is true, skip JOBROLE_ID validation
//     }
//     console.log("I m here",data.IS_ALL_JOBROLE)
//     return data.JOBROLE_ID.length > 0;
//   },
//   {
//     message: "At least one role must be selected",
//     path: ["JOBROLE_ID"],
//   }
// );

const FIELD_TYPE_DEFAULTS = {
  FirstName: { label: 'First Name', width: 200, height: 30, options: [] },
  LastName: { label: 'Last Name', width: 200, height: 30, options: [] },
  description: { label: 'Text', width: 200, height: 30, options: [] },
  signature: { label: 'Signature', width: 200, height: 100, options: [] },
  Phone: { label: 'Phone Number', width: 150, height: 30, options: [] },
  Email: { label: 'Email', width: 200, height: 30, options: [] },
  Stamp: { label: 'Stamp', width: 100, height: 100, options: [] },
  Formula: { label: 'Formula', width: 200, height: 30, options: [] },
  // Attachment: { label: 'Attachment', width: 200, height: 30, options: [] },
  Radio: { label: 'Radio Button', width: 200, height: 30, options: [] },
  DateTime: { label: 'Date & Time', width: 200, height: 30, options: [] },
  Checkbox: { label: 'Checkbox', width: 200, height: 30, options: [] },
  Dropdown: { label: 'Dropdown', width: 200, height: 30, options: [] },
};

const getDefaultFieldConfig = (fieldType, fallbackLabel) => {
  const defaultConfig = FIELD_TYPE_DEFAULTS[fieldType] || {
    label: fallbackLabel || 'Field',
    width: 200,
    height: 30,
    options: []
  };
  return {
    label: defaultConfig.label,
    width: defaultConfig.width,
    height: defaultConfig.height,
    options: [...defaultConfig.options]
  };
};

const AddOnBoardingDocuments2 = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { values } = useSelector((state) => state?.multiStep);
  const [checked, setChecked] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [roles, setRoles] = useState([]);
  const [label1, setLabel1] = useState(values?.label1 || []);
  const [label2, setLabel2] = useState(values?.label2 || []);
  const [checkBoxLabel, setCheckBoxLabel] = useState("");
  const [dropdownLabel, setDropdownLabel] = useState("");

  const [jobRoleMessage, setJobRoleMessage] = useState("")
  const [dropdownTitle, setDropdownTitle] = useState("");
  const [options, setOptions] = useState([]);
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfName, setPdfName] = useState('');
  const [fields, setFields] = useState([]);
  const [selectedField, setSelectedField] = useState(null);
  const [fileValue, setFileValue] = useState(null);
  const [fileName, setFileName] = useState('');
  const [pdfEditorFields, setPdfEditorFields] = useState([]);

  console.log(values.ID, "values in add document 2");

  // Fetch document details by ID using useTQuery
  const { data: documentDetails, isLoading: isDocumentLoading, isError: isDocumentError } = useTQuery(
    ["adminOnBoardingDocument", values?.ID],
    values?.ID ? `/fetchAdminOnBoardingDocumentByID?${new URLSearchParams({ id: values.ID })}` : null,
    'get'
  );

  // Handle the fetched document details
  useEffect(() => {
    if (documentDetails?.OUTPUT) {
      const { OUTPUT } = documentDetails;

      // Set the PDF file URL
      if (OUTPUT.PDF_FILE_NAME) {
        const pdfUrl = `${FRONTEND_URL}documents/${OUTPUT.PDF_FILE_NAME}`;
        setPdfFile(pdfUrl);
        setPdfName(OUTPUT.PDF_FILE_NAME);
      }

      // Set PDF editor fields if they exist
      if (OUTPUT.PDF_EDITOR_FIELDS && Array.isArray(OUTPUT.PDF_EDITOR_FIELDS)) {
        const formattedFields = OUTPUT.PDF_EDITOR_FIELDS.map(field => ({
          ...field,
          x: field.x || 50,  // Default x if not provided
          y: field.y || 50,  // Default y if not provided
          width: field.width || 150,  // Default width if not provided
          height: field.height || 30,  // Default height if not provided
          isExtracted: field.isExtracted || false
        }));
        setPdfEditorFields(formattedFields);
      }

      // Set document fields component if they exist
      if (OUTPUT.DOCUMENT_FIELDS_COMPONENT && Array.isArray(OUTPUT.DOCUMENT_FIELDS_COMPONENT)) {
        setFieldData(JSON.parse(JSON.stringify(OUTPUT.DOCUMENT_FIELDS_COMPONENT)));
      } else if (values?.documentField && Array.isArray(values.documentField)) {
        // Fallback to navigation state if API doesn't have DOCUMENT_FIELDS_COMPONENT
        setFieldData(JSON.parse(JSON.stringify(values.documentField)));
      }

      // Set labels if they exist
      if (OUTPUT.LABEL1 && Array.isArray(OUTPUT.LABEL1)) {
        setLabel1(OUTPUT.LABEL1);
      }
      if (OUTPUT.LABEL2 && Array.isArray(OUTPUT.LABEL2)) {
        setLabel2(OUTPUT.LABEL2);
      }

      // Set IS_ALL_JOBROLE if it exists
      if (OUTPUT.IS_ALL_JOBROLE !== undefined) {
        setChecked(OUTPUT.IS_ALL_JOBROLE);
        setValue('IS_ALL_JOBROLE', OUTPUT.IS_ALL_JOBROLE);
      }

      // Set other form fields
      if (OUTPUT.DOCUMENT_NAME) {
        setValue('DOCUMENT_NAME', OUTPUT.DOCUMENT_NAME);
      }
      if (OUTPUT.REQUIREMENT) {
        setValue('REQUIREMENT', OUTPUT.REQUIREMENT);
      }
      if (OUTPUT.DOCUMENT_DESCRIPION) {
        setValue('DOCUMENT_DESCRIPION', OUTPUT.DOCUMENT_DESCRIPION);
      }
      if (OUTPUT.DOCUMENT_STATUS) {
        setValue('DOCUMENT_STATUS', OUTPUT.DOCUMENT_STATUS);
      }

      // Set job roles if available
      if (OUTPUT.JOBROLE_ID && Array.isArray(OUTPUT.JOBROLE_ID)) {
        setSelectedRoles(OUTPUT.JOBROLE_ID);
      }
    }
  }, [documentDetails]);


  const {
    data: fetchJobRole = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["jobRoles"],
    queryFn: fetchJobRoles,
    staleTime: 1000 * 60 * 2,
  });

  const onDrop = (acceptedFiles, fileRejections) => {
    try {
      // If there are rejected files, log or handle them
      if (fileRejections && fileRejections.length > 0) {
        console.warn("Some files were rejected:", fileRejections);
        return;
      }

      if (!acceptedFiles || acceptedFiles.length === 0) {
        console.warn("No file was dropped.");
        return;
      }

      const file = acceptedFiles[0];
      console.log('File dropped:', file.name, file.type, file.size);

      // Validate file type
      if (file.type !== 'application/pdf') {
        console.warn("Unsupported file type:", file.type);
        return;
      }

      // Additional validation
      if (file.size === 0) {
        console.error("File is empty");
        return;
      }

      console.log('Setting PDF file:', file);
      setPdfFile(file);
      setFileName(file.name);
      // Reset any previous editor fields so new uploads start clean
      setPdfEditorFields([]);

    } catch (error) {
      console.error("Error processing dropped file:", error);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf']
    },
    multiple: false,
    onError: (err) => {
      console.error("Dropzone internal error:", err);
    }
  });

  const handlePdfSave = async (newPdfFile, extra) => {
    setPdfFile(newPdfFile);
    setFileName(newPdfFile.name);
    if (extra && Array.isArray(extra.fields)) {
      setPdfEditorFields(extra.fields);
    }

    try {
      // Immediately persist updated PDF editor fields so deletions are permanent
      const formData = new FormData();
      formData.append('FILE_NAME', newPdfFile);
      formData.append('LABEL1', JSON.stringify(label1));
      formData.append('LABEL2', JSON.stringify(label2));
      formData.append('ID', values.value?.ID || values?.ID || '');
      formData.append('IS_ALL_JOBROLE', getValues('IS_ALL_JOBROLE') || false);
      formData.append('DOCUMENT_FIELDS_COMPONENT', JSON.stringify(fieldData));
      formData.append('PDF_EDITOR_FIELDS', JSON.stringify((extra && Array.isArray(extra.fields)) ? extra.fields : []));
      const currentJobRoles = getValues('JOBROLE_ID') || selectedRoles || [];
      formData.append('JOBROLE_ID', JSON.stringify(Array.isArray(currentJobRoles) ? currentJobRoles : [currentJobRoles]));

      const response = await mutateAsync(formData);
      if (!response?.STATUS) {
        showToast('error', 'Failed to save PDF changes.', 3000);
      }
    } catch (err) {
      showToast('error', 'Failed to save PDF changes.', 3000);
    }
  };

  useEffect(() => {
    if (fetchJobRole) {
      setRoles(fetchJobRole);
    }
  }, [fetchJobRole]);

  useEffect(() => {
    if (values.JOBROLE_ID) setSelectedRoles(values.JOBROLE_ID);
  }, [values]);

  const {
    control,
    register,
    setValue,
    watch,
    setError,
    getValues,
    clearErrors,
    trigger,
    handleSubmit,
    formState: { errors },
  } = useForm({
    // resolver: zodResolver(jobRoleSchema),  
    defaultValues: {
      DOCUMENT_NAME: values.DOCUMENT_NAME || values.value.DOCUMENT_NAME || "",
      REQUIREMENT: values?.REQUIREMENT || values.value.REQUIREMENT || "",
      DOCUMENT_DESCRIPION: values?.DOCUMENT_DESCRIPION || "",
      JOBROLE_ID: values?.JOBROLE_ID || [],
      DOCUMENT_STATUS: values?.DOCUMENT_STATUS || "Active",
      IS_ALL_JOBROLE: checked || false,
      FILE_NAME: null,
    },
  });

  const { mutateAsync } = useTMutation(
    "/addOnBoardingDocument",
    "post",
    (response) => {
      if (response.STATUS) {
        return response;
      }
    }
  );

  // Sync local state with form state on mount
  useEffect(() => {
    const formValue = getValues("IS_ALL_JOBROLE");
    if (formValue !== checked) {
      setChecked(formValue);
    }
  }, []);

  const handleChipDelete = (jobRoleID) => {
    setSelectedRoles((prev) => prev.filter((id) => id !== jobRoleID));
    setValue(
      "JOBROLE_ID",
      selectedRoles.filter((id) => id !== jobRoleID)
    );
    clearErrors("JOBROLE_ID");
  };

  const handleRoleChange = (event) => {
    const selectedRoleId = event.target.value;
    if (selectedRoleId && !selectedRoles.includes(selectedRoleId)) {
      const updatedRoles = [...selectedRoles, selectedRoleId];
      setSelectedRoles(updatedRoles);
      setValue("JOBROLE_ID", updatedRoles);

      trigger("JOBROLE_ID");
    }
    setJobRoleMessage("");
  };

  const mapInput = (data) => {
    if (data.name == "LABEL1") {
      if (data.value == "") {
        setError("LABEL1", {
          type: "manual",
          message: "Add Label",
        });
      } else {
        setLabel1([...label1, data.value]);
      }
    } else if (data.name == "LABEL2") {
      if (data.value == "") {
        setError("LABEL2", {
          type: "manual",
          message: "Add Label",
        });
      } else {
        setLabel2([...label2, data.value]);
      }
    }
  };

  const deleteInput = (data) => {
    if (data.name == "LABEL1") {
      const filterlabel1 = label1.filter((item, index) => index !== data.value);
      setLabel1(filterlabel1);
    } else if (data.name == "LABEL2") {
      const filterlabel2 = label2.filter((item, index) => index !== data.value);
      setLabel2(filterlabel2);
    }
  };

  const submitAddDocument = async (data) => {
    console.log("Form data:", data); // Debug form data
    console.log("PDF Editor Fields:", pdfEditorFields); // Debug PDF editor fields
    console.log("All roles:", roles); // Debug all available roles

    // Validate that a PDF file is uploaded
    if (!pdfFile) {
      showToast("error", "Please upload a PDF document", 3000);
      return;
    }

    if (fieldData?.[6]?.consent?.length > 0) {
      if (fieldData?.[6]?.consent?.[0]?.field === "") {
        showToast("error", "Consent is empty", 3000);
        return;
      }
    }

    // If "Set for all job types" is checked, use all job role IDs
    let jobRoleIds = [];
    if (data.IS_ALL_JOBROLE) {
      // Get all job role IDs from the roles array
      jobRoleIds = roles?.map(role => role.ID) || [];
      if (jobRoleIds.length === 0) {
        showToast("error", "No job roles found", 3000);
        return;
      }
    } else {
      // Use selected job roles
      if (!data.JOBROLE_ID || data.JOBROLE_ID.length === 0) {
        setJobRoleMessage("At least one job role is required");
        return;
      }
      jobRoleIds = Array.isArray(data.JOBROLE_ID) ? data.JOBROLE_ID : [data.JOBROLE_ID];
    }

    console.log("Job Role IDs to be saved:", jobRoleIds);

    const formData = new FormData();
    formData.append('DOCUMENT_NAME', data?.DOCUMENT_NAME);
    formData.append('REQUIREMENT', data?.REQUIREMENT);
    formData.append('DOCUMENT_STATUS', data?.DOCUMENT_STATUS);
    formData.append('FILE_NAME', pdfFile);
    formData.append('LABEL1', JSON.stringify(label1));
    formData.append('LABEL2', JSON.stringify(label2));
    formData.append('ID', values.value?.ID || values?.ID || '');
    formData.append('IS_ALL_JOBROLE', data.IS_ALL_JOBROLE || false);
    formData.append('DOCUMENT_FIELDS_COMPONENT', JSON.stringify(fieldData));
    formData.append('PDF_EDITOR_FIELDS', JSON.stringify(pdfEditorFields || []));
    formData.append('JOBROLE_ID', JSON.stringify(jobRoleIds));

    try {
      const response = await mutateAsync(formData);
      if (response.STATUS) {
        showToast("success", response.MESSAGE, 3000);
        navigate("/admin/profile-criteria/OnBoardingDocuments");
      } else {
        showToast("error", data.MESSAGE, 3000);
      }
    } catch (error) {
      showToast("Add Request failed");
    }
  };

  const [value, setValues] = useState({
    component: "",
  });
  const initialFieldData = [
    { email: [] },
    { Phone: [] },
    { stamp: [] },
    { formula: [] },
    { attachment: [] },
    { radio: [] },
    { dateTime: [] },
    { checkBox: [] },
    { dropdown: [] }
  ];

  const [fieldData, setFieldData] = useState(initialFieldData);

  const [fieldValue, setFieldValue] = useState({
    field: "",
    label: "",
  });
  const [consentValue, setConsent] = useState("")
  const [checkBoxValue, setCheckBoxValue] = useState({
    fieldLabel: "",
    value: [],
  });
  const [dropdownValue, setDropdownValue] = useState({
    fieldLabel: "",
    value: [],
  });
  const handleChange = (key, value, functionvalue) => {
    functionvalue((prev) => ({ ...prev, [key]: value }));
  };

  const addComponent = () => {
    if (value?.component === "Email") {
      let fieldDataUse = {
        field: "textField",
        label: "email",
      }
      fieldData[0]?.email.push(fieldDataUse);
    }
    else if (value?.component === "Phone") {
      let fieldDataUse = {
        field: "textField",
        label: "Phone",
      }
      fieldData[1]?.Phone.push(fieldDataUse);
    }
    else if (value?.component === "Stamp") {
      let fieldDataUse = {
        field: "stamp",
        label: "Stamp",
      }
      fieldData[2]?.stamp.push(fieldDataUse);
    }
    else if (value?.component === "Formula") {
      let fieldDataUse = {
        field: "formula",
        label: "Formula",
        expression: ""
      }
      fieldData[3]?.formula.push(fieldDataUse);
    }
    else if (value?.component === "Attachment") {
      let fieldDataUse = {
        field: "attachment",
        label: "Attachment",
        allowedTypes: ["pdf", "jpg", "png"]
      }
      fieldData[4]?.attachment.push(fieldDataUse);
    }
    else if (value?.component === "Radio") {
      const newRadio = {
        fieldLabel: dropdownTitle,
        value: options,
        selected: ""
      };
      if (options.length > 0) {
        setFieldData(prevFieldData => {
          const updatedFieldData = [...prevFieldData];
          if (!updatedFieldData[5]) {
            updatedFieldData[5] = { radio: [] };
          }
          updatedFieldData[5].radio.push(newRadio);
          return updatedFieldData;
        });
        setDropdownTitle("");
        setOptions([]);
      }
    }
    else if (value?.component === "DateTime") {
      let fieldDataUse = {
        field: "dateTime",
        label: "Date & Time",
        includeTime: true
      }
      fieldData[6]?.dateTime.push(fieldDataUse);
    }
    else if (value?.component === "Checkbox") {
      if (checkBoxValue?.value?.length > 0) {
        fieldData[7]?.checkBox.push(checkBoxValue);
        setCheckBoxValue(
          {
            fieldLabel: "",
            value: [],
          }
        )
      }
    }
    else if (value?.component === "Dropdown") {
      const newDropdown = {
        fieldLabel: dropdownTitle,
        value: options,
      };
      if (options.length > 0) {
        setFieldData(prevFieldData => {
          const updatedFieldData = [...prevFieldData];
          if (!updatedFieldData[8]) {
            updatedFieldData[8] = { dropdown: [] };
          }
          updatedFieldData[8].dropdown.push(newDropdown);
          return updatedFieldData;
        });
        setDropdownTitle("");
        setOptions([]);
      }
    }
    setFieldValue("");
    setValues("");
  };

  const addCheckBox = () => {
    if (checkBoxLabel !== "") {
      checkBoxValue?.value?.push({ labelCheck: checkBoxLabel });
    }
    setCheckBoxLabel("");
  };


  const handleDelete = (provide, index) => {
    if (provide === "email") {
      setFieldData((prev) => {
        const updatedFieldData = [...prev];
        updatedFieldData[0].email = updatedFieldData[0].email.filter(
          (_, i) => i !== 0
        );
        return updatedFieldData;
      });
    }
    else if (provide === "phone") {
      setFieldData((prev) => {
        const updatedFieldData = [...prev];
        updatedFieldData[1].Phone = updatedFieldData[1].Phone.filter(
          (_, i) => i !== 0
        );
        return updatedFieldData;
      });
    }
    else if (provide === "stamp") {
      setFieldData((prev) => {
        const updatedFieldData = [...prev];
        updatedFieldData[2].stamp = updatedFieldData[2].stamp.filter(
          (_, i) => i !== 0
        );
        return updatedFieldData;
      });
    }
    else if (provide === "formula") {
      setFieldData((prev) => {
        const updatedFieldData = [...prev];
        updatedFieldData[3].formula = updatedFieldData[3].formula.filter(
          (_, i) => i !== 0
        );
        return updatedFieldData;
      });
    }
    else if (provide === "attachment") {
      setFieldData((prev) => {
        const updatedFieldData = [...prev];
        updatedFieldData[4].attachment = updatedFieldData[4].attachment.filter(
          (_, i) => i !== 0
        );
        return updatedFieldData;
      });
    }
    else if (provide === "radio") {
      setFieldData((prev) => {
        const updatedFieldData = [...prev];
        updatedFieldData[5].radio = updatedFieldData[5].radio.filter(
          (_, i) => i !== index
        );
        return updatedFieldData;
      });
    }
    else if (provide === "dateTime") {
      setFieldData((prev) => {
        const updatedFieldData = [...prev];
        updatedFieldData[6].dateTime = updatedFieldData[6].dateTime.filter(
          (_, i) => i !== 0
        );
        return updatedFieldData;
      });
    }
  };

  const handleDeleteCheckBox = (provide, index, labelIndex) => {
    if (provide === "value") {
      setCheckBoxValue((prev) => {
        const updatedFieldData = { ...prev };
        updatedFieldData.value = updatedFieldData.value.filter(
          (_, i) => i !== index
        );
        return updatedFieldData;
      });


    } else if (provide === "chekBoxField") {
      setFieldData((prev) => {
        const updatedFieldData = [...prev];

        updatedFieldData[4].checkBox[labelIndex].value = updatedFieldData[4]?.checkBox[labelIndex].value?.filter(
          (_, i) => i !== index
        );
        if (updatedFieldData[4].checkBox[labelIndex]?.value?.length === 0) {
          updatedFieldData[4].checkBox = updatedFieldData[4]?.checkBox?.filter(
            (_, i) => i !== labelIndex
          );
        }
        return updatedFieldData;
      });
    }
  }
  const addDropdownOption = () => {
    if (dropdownLabel.trim() !== "" && !options.includes(dropdownLabel)) {
      setOptions([...options, dropdownLabel]);
      setDropdownLabel(""); // Clear input after adding
    }

  };
  //Editor Dropdown add new options
  const addNewDropdownOption = (dropdownIndex) => {
    setFieldData(prevFieldData => {
      const updatedFieldData = [...prevFieldData];
      if (updatedFieldData[5].dropdown[dropdownIndex].value.some(option => option === "")) {
        return prevFieldData
      }
      updatedFieldData[5].dropdown[dropdownIndex].value.push("");
      return updatedFieldData;
    });
  };

  //Editor Dropdown update options
  const updateOption = (dropdownIndex, optionIndex, newValue) => {
    setFieldData(prevFieldData => {
      const updatedFieldData = [...prevFieldData];
      updatedFieldData[5].dropdown[dropdownIndex].value[optionIndex] = newValue;
      return updatedFieldData;
    });
  };

  //Editor Dropdown Remove options 
  const removeDropdownOption = (dropdownIndex, optionIndex) => {
    setFieldData(prevFieldData => {
      const updatedFieldData = [...prevFieldData];
      updatedFieldData[5].dropdown[dropdownIndex].value.splice(optionIndex, 1);
      return updatedFieldData;
    });
  };

  const removeOption = (optionToRemove) => {
    setOptions(options.filter(option => option !== optionToRemove));
  };
  const removeDropdown = (index) => {
    setFieldData(prevFieldData => {
      const updatedFieldData = [...prevFieldData];
      updatedFieldData[5].dropdown.splice(index, 1);
      return updatedFieldData;
    });
  };

  const handleChanges = (e) => {
    setConsent(e.target.value)
    fieldData[6].consent[0].field = e.target.value;
  }

  // Upload file Code

  const { controlBy, controlAction } = useSelector(state => state.user);
  // const NoAccess = (controlBy === 'admin' || controlBy === 'facility');
  // const disabledField = (controlBy === 'admin' || controlBy === 'facility') && controlAction === 'view';

  const { selectedTabData } = useSelector((state) => state.profileTabSection)
  const [uploadedFilePath, setUploadedFilePath] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const loadInitialData = async () => {
      if (selectedTabData?.about?.FILE_NAME) {
        setUploadedFilePath(API_URL + "user/viewFile?fileName=" + selectedTabData.about.FILE_NAME);
        File = await getStringAfterLastSlash(selectedTabData.about.FILE_NAME);
      }
    }
    loadInitialData();
  }, [selectedTabData?.about?.FILE_NAME]);

  const mutation = useTMutation("/profile", "patch", (data) => {
    if (data.STATUS) {
      showToast("success", data.MESSAGE, 3000);
      return data;
    } else {
      showToast("error", data.MESSAGE, 3000);
    }
  });

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append('file', data.FILE_NAME); // File can be appended directly            
      formData.append('USER_ID', selectedTabData?.about?.USER_ID);


      const response = await mutation.mutateAsync(formData);
      if (response.STATUS) {
        navigate(-1);
      }
    } catch (error) {
      console.log("Request saved details error", error.message);
    }
  };

  const handleBacktoHome = () => {
    let route = '/clinician/profile';
    if (controlBy === "admin") {
      route = `/admin/clinician-users/view?${selectedTabData?.about?.USER_TYPE}=${selectedTabData?.about?.FIRST_NAME + " " + selectedTabData?.about?.LAST_NAME}`
    } else if (controlBy === "facility") {
      route = -1;
    }
    navigate(route);
  }

  const handleFileValidation = useCallback(
    (file) => {
      if (!file || (file.size > 5 * 1024 * 1024)) {
        return false;
      }
      if (!['application/pdf', 'image/jpeg', 'image/png'].includes(file.type)) {
        return false;
      }

      clearErrors('FILE_NAME');
      return true;
    }, [clearErrors]);

  const handleDrop = useCallback((event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    setValue("FILE_NAME", file, { shouldValidate: true });
    if (handleFileValidation(file)) {
      setFileName(file.name);
    }
  }, [handleFileValidation, setValue]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const downloadPdfFile = () => {
    if (!pdfFile) return;

    const url = URL.createObjectURL(pdfFile);
    const link = document.createElement('a');
    link.href = url;
    link.download = pdfFile.name || 'download.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const onDragStartField = (e, fieldType, fallbackLabel) => {
    const { label: defaultLabel, width: defaultWidth, height: defaultHeight, options: defaultOptions } =
      getDefaultFieldConfig(fieldType, fallbackLabel);

    let label = defaultLabel;
    let width = defaultWidth;
    let height = defaultHeight;
    let fieldOptions = [...defaultOptions];

    switch (fieldType) {
      case "Picklist": {
        const picklistFields = fieldData?.[3]?.pickField || [];
        if (picklistFields.length > 0) {
          fieldOptions = picklistFields[0].options || fieldOptions;
        }
        break;
      }
      case "Checkbox": {
        const checkboxFields = fieldData?.[4]?.checkBox || [];
        if (checkboxFields.length > 0) {
          fieldOptions = checkboxFields[0].value?.map((v) => v.labelCheck) || fieldOptions;
        }
        break;
      }
      case "Dropdown": {
        const dropdownFields = fieldData?.[5]?.dropdown || [];
        if (dropdownFields.length > 0) {
          fieldOptions = dropdownFields[0].value || fieldOptions;
        }
        break;
      }
      case "Radio": {
        const radioFields = fieldData?.[5]?.radio || [];
        if (radioFields.length > 0) {
          fieldOptions = radioFields[0].value || fieldOptions;
        }
        break;
      }
      default:
        break;
    }

    const payload = JSON.stringify({ type: fieldType, label, width, height, options: fieldOptions });
    console.log(payload, "payload");
    e.dataTransfer.setData('application/x-pdf-field', payload);
    e.dataTransfer.effectAllowed = 'copyMove';
  };


  return (


    <Grid
      container
      spacing={2}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start">
      {!values.REDIRECT && (
        <Button
          onClick={() => dispatch(previousStep())}
          startIcon={
            <ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />
          }
          sx={{
            textTransform: "none",
            fontWeight: 500,
            fontSize: "14px",
            padding: 3,
            minWidth: 0,
            marginTop: -1,
          }}></Button>
      )}

      <Grid item xs={12} mt={-2}>
        <form onSubmit={handleSubmit(submitAddDocument)}>
          <Grid container spacing={2} direction="row">

            {/* Component section */}
            <Grid item xs={12} sm={2} className="component-section">
              <Card
                sx={{
                  padding: { xs: '1rem', sm: '1.5rem' },
                  display: "flex",
                  borderRadius: "8px",
                  minHeight: "80vh",
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  '&.MuiPaper-root': {
                    padding: '20px !important'
                  }
                }}
                className="component-section-card"
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  {/* COMPONENTS HEADER */}
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{
                      fontWeight: "bold",
                      color: "#2E7D32",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                      mb: 1,
                      pb: 1,
                      borderBottom: "3px solid #6EBE44",
                      display: "inline-block",
                    }}
                  >
                    Components
                  </Typography>

                  {/* Document Fields */}

                  <Grid item xs={12} display="flex" flexDirection="column" gap={2}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 600,
                        fontSize: "17px",
                        color: "#25419eff",
                        letterSpacing: 0.5,
                        mb: 0.8,
                      }}
                    >
                      Document Fields
                      <Divider sx={{ borderColor: "#25419eff" }} />
                      <Typography
                        component="span"
                        sx={{
                          color: "#6b7280",
                          fontSize: "11px",
                          fontWeight: 500,
                          display: "block",
                          mt: 0.3,
                        }}
                      >
                        Drag and drop fields onto the PDF editor
                      </Typography>
                    </Typography>

                    <Box
                      sx={{
                        border: "2px dashed #5348f1ff",
                        borderRadius: "12px",
                        p: 2,
                        mb: 0,
                        backgroundColor: "#f9fafb",
                        maxHeight: 260,
                        overflowY: "auto",
                        display: "grid",
                        fontSize: "10px",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: 1,
                        "&:hover": {
                          borderColor: "#6EBE44",
                          backgroundColor: "#c1c0faff",
                        },
                      }}
                    >
                      {[
                        { key: "FirstName", label: "FirstName", disabled: false },
                        { key: "LastName", label: "LastName", disabled: false },
                        { key: "description", label: "Text", disabled: false },
                        { key: "signature", label: "Signature", disabled: false },
                        { key: "Phone", label: "Phone Number", disabled: fieldData?.[1]?.Phone?.length > 0 },
                        { key: "Email", label: "Email", disabled: fieldData?.[0]?.email?.length > 0 },
                        { key: "Stamp", label: "Stamp", disabled: fieldData?.[2]?.stamp?.length > 0 },
                        { key: "Formula", label: "Formula", disabled: false },
                        // { key: "Attachment", label: "Attachment", disabled: fieldData?.[4]?.attachment?.length > 0 },
                        { key: "Radio", label: "Radio Button", disabled: false },
                        { key: "DateTime", label: "Date & Time", disabled: fieldData?.[6]?.dateTime?.length > 0 },
                        { key: "Checkbox", label: "Checkbox", disabled: false },
                        { key: "Dropdown", label: "Dropdown", disabled: false },
                      ].map((field) => (
                        <Box
                          key={field.key}
                          draggable={!field.disabled}
                          className={`draggable-field ${field.disabled ? "disabled" : ""}`}
                          onDragStart={(e) => {
                            if (field.disabled) return;

                            onDragStartField(e, field.key, field.label);
                            e.dataTransfer.setDragImage(e.target, 10, 10);
                          }}
                          onClick={() =>
                            !field.disabled && handleChange("component", field.key, setValues)
                          }
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: 1,
                            backgroundColor: field.disabled
                              ? "#f0e4bb"
                              : value?.component === field.key
                                ? "#d9ebde"
                                : "#ffffff",
                            border: "1px solid #05d839ff",
                            borderRadius: "4px",
                            px: 0.2,
                            py: 0.5,
                            fontSize: "12px",
                            fontWeight: 500,
                            color: field.disabled ? "#a897f5ff" : "#111",
                            cursor: field.disabled ? "not-allowed" : "grab",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            transition: "all 0.2s ease-in-out",
                            "&:hover": {
                              backgroundColor: "#67dd85ff",
                              transform: "translateY(-2px)",
                              boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                            },
                          }}
                        >
                          <DragIndicatorIcon
                            sx={{
                              fontSize: "16px",
                              color: field.disabled ? "#bbb" : "#6EBE44",
                              cursor: field.disabled ? "not-allowed" : "grab",
                            }}
                          />
                          <Typography variant="body2">{field.label}</Typography>
                        </Box>
                      ))}
                    </Box>
                  </Grid>

                  {/* Attach Document */}
                  <Typography
                    gutterBottom
                    sx={{
                      fontWeight: 700,
                      fontSize: "17px",
                      color: "#25419eff",
                      mb: 1,
                      borderBottom: "2px solid #25419eff",
                      display: "inline-block",
                      pb: 0.5,
                    }}
                  >
                    Attach Document <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <div style={{ padding: "5px" }}>
                    <Box
                      {...getRootProps()}
                      sx={{
                        mt: 1,
                        p: 2,
                        border: "2px dashed #25419eff",
                        borderRadius: "12px",
                        backgroundColor: "#f8faf9",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "120px",
                        transition: "all 0.3s ease-in-out",
                        cursor: "pointer",
                        "&:hover": {
                          borderColor: "#6EBE44",
                          backgroundColor: "#f0fdf4",
                        },
                      }}
                    >
                      <input {...getInputProps()} accept=".pdf" style={{ display: "none" }} />

                      {fileName ? (
                        <Box
                          sx={{
                            width: "100%",
                            backgroundColor: "#ffffff",
                            border: "1px solid #d1d5db",
                            borderRadius: "10px",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            transition: "0.3s",
                            "&:hover": {
                              transform: "scale(1.01)",
                              boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                            },
                          }}
                        >
                          {/* Inner Box with Icon and Label */}
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <InsertDriveFileIcon sx={{ color: "#6EBE44", fontSize: 40 }} />
                            <Typography
                              variant="caption"
                              sx={{ color: "#171817ff", fontSize: "12px", mt: 1 }}
                            >
                              PDF Document
                            </Typography>
                          </Box>

                          {/* Outer Box with File Name and Remove */}
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 0.5,
                              alignItems: "flex-start",
                              maxWidth: "100%",
                              overflow: "hidden",
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              sx={{
                                color: "#000",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "calc(100% - 24px)",
                              }}
                            >
                              {fileName}
                            </Typography>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setPdfFile(null);
                                setFileName("");
                                setValue("FILE_NAME", null);
                                setFields([]);
                              }}
                              sx={{
                                color: "#666",
                                "&:hover": {
                                  backgroundColor: "rgba(211, 19, 5, 0.1)",
                                  color: "#e70b0bff",
                                },
                              }}
                            >
                              <Close fontSize="small" />
                            </IconButton>
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{
                              mb: 2,
                              color: "#6EBE44",
                              borderColor: "#6EBE44",
                              "&:hover": {
                                backgroundColor: "rgba(110,190,68,0.1)",
                              },
                            }}
                          >
                            Browse Files
                          </Button>
                          <VscCloudUpload
                            style={{ fontSize: 48, color: "#6EBE44", marginBottom: 16 }}
                          />
                          <Typography variant="caption" sx={{ color: "#888" }}>
                            Drag & drop PDF here. Maximum file size: 10MB
                          </Typography>
                        </>
                      )}
                    </Box>

                    {errors.FILE_NAME && (
                      <Typography color="error" variant="caption">
                        {errors.FILE_NAME.message}
                      </Typography>
                    )}
                    {!errors.FILE_NAME && (
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ mt: 1, display: "block" }}
                      >
                        PDF document is required for form creation
                      </Typography>
                    )}
                  </div>





                </Box>
              </Card>
            </Grid>

            {/* PDF Editor */}
            {/* ========================= PDF EDITOR SECTION (Updated UI + Functional) ========================= */}
            <Grid item xs={12} sm={7}>
              <Card
                sx={{
                  padding: "1rem",
                  borderRadius: "12px",
                  minHeight: "80vh",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  backgroundColor: "#f8faf9",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                }}
              >
                {/* ======================== If PDF Uploaded ======================== */}
                {pdfFile ? (
                  <Box sx={{ position: "relative", height: "80vh", overflowY: "auto" }}>
                    {/* Toolbar Above PDF */}
                    <Box
                      sx={{
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        background: "#ffffff",
                        p: 2,
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        gap: 1.5,
                        borderBottom: "2px solid #e0e0e0",
                      }}
                    >
                      {[
                        { key: "FirstName", label: FIELD_TYPE_DEFAULTS.FirstName.label },
                        { key: "LastName", label: FIELD_TYPE_DEFAULTS.LastName.label },
                        { key: "description", label: FIELD_TYPE_DEFAULTS.description.label },
                        { key: "signature", label: FIELD_TYPE_DEFAULTS.signature.label },
                        { key: "Phone", label: FIELD_TYPE_DEFAULTS.Phone.label },
                        { key: "Email", label: FIELD_TYPE_DEFAULTS.Email.label },
                        { key: "Stamp", label: FIELD_TYPE_DEFAULTS.Stamp.label },
                        { key: "Formula", label: FIELD_TYPE_DEFAULTS.Formula.label },
                        // { key: "Attachment", label: FIELD_TYPE_DEFAULTS.Attachment.label },
                        { key: "Radio", label: FIELD_TYPE_DEFAULTS.Radio.label },
                        { key: "DateTime", label: FIELD_TYPE_DEFAULTS.DateTime.label },
                        { key: "Checkbox", label: FIELD_TYPE_DEFAULTS.Checkbox.label },
                        { key: "Dropdown", label: FIELD_TYPE_DEFAULTS.Dropdown.label },
                        // { key: "SSN", label: "SSN" },
                        // { key: "Picklist", label: "Picklist" },
                        // { key: "Consent", label: "Consent" },
                        // { key: "Address", label: "Address" },
                        // { key: "Company", label: "Company" },
                      ].map((field) => (
                        <Box
                          key={field.key}
                          draggable
                          onDragStart={(e) => onDragStartField(e, field.key, field.label)}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.8,
                            px: 1,
                            py: 0.6,
                            borderRadius: "10px",
                            fontSize: "0.82rem",
                            fontWeight: 500,
                            backgroundColor: "#ffffff",
                            border: "1.5px solid #6EBE44",
                            cursor: "grab",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            transition: "all 0.2s ease-in-out",
                            "&:hover": {
                              backgroundColor: "#f0fdf4",
                              transform: "translateY(-2px)",
                            },
                          }}
                        >
                          <DragIndicatorIcon sx={{ fontSize: 16, color: "#6EBE44" }} />
                          {field.label}
                        </Box>
                      ))}
                    </Box>

                    {/* PDF Viewer */}
                    <Box sx={{ position: "relative", p: 1, height: '100%' }}>
                      <PdfEditorAdmin
                        pdfFile={pdfFile}
                        pdfName={fileName}
                        onSave={handlePdfSave}
                        onFieldsChange={(updatedFields) => {
                          // Ensure fields have required properties
                          const processedFields = updatedFields.map(field => ({
                            ...field,
                            type: field.type || 'text',
                            x: Number(field.x) || 50,
                            y: Number(field.y) || 50,
                            width: field.type === 'signature' ? (Number(field.width) || 200) : (Number(field.width) || 150),
                            height: field.type === 'signature' ? (Number(field.height) || 100) : (Number(field.height) || 30),
                            label: field.label || (field.type === 'signature' ? 'Signature' : 'Text'),
                            page: Number(field.page) || 1,
                            isExtracted: Boolean(field.isExtracted),
                            options: Array.isArray(field.options) ? field.options : [],
                            picklistOptions: Array.isArray(field.picklistOptions) ? field.picklistOptions : [],
                            isRequired: field.isRequired === true,
                          }));
                          setPdfEditorFields(processedFields);
                        }}
                        initialFields={pdfEditorFields}
                        isReadOnly={false}
                        showPreview={true}
                        pdfWidth="100%"
                        pdfHeight="100%"
                        style={{ height: '100%' }}
                      />

                      {/* Remove PDF Button */}
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => {
                          setPdfFile(null);
                          setFileName("");
                          // Clear any existing fields so the next uploaded PDF starts clean
                          setPdfEditorFields([]);
                        }}
                        sx={{
                          position: "absolute",
                          top: 20,
                          right: 20,
                          color: "#ff1744",
                          borderColor: "#ff1744",
                          backgroundColor: "#fff",
                          "&:hover": {
                            backgroundColor: "rgba(255, 23, 68, 0.1)",
                            borderColor: "#ff1744",
                          },
                        }}
                      >
                        Remove PDF
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  /* ======================== When No PDF Uploaded ======================== */
                  <Box
                    {...getRootProps()}
                    sx={{
                      height: "80vh",
                      border: "2px dashed #25419eff",
                      borderRadius: "12px",
                      backgroundColor: "#f8faf9",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 3,
                      transition: "all 0.3s ease-in-out",
                      cursor: "pointer",
                      "&:hover": {
                        borderColor: "#6EBE44",
                        backgroundColor: "#f0fdf4",
                      },
                    }}
                  >
                    <input {...getInputProps()} accept=".pdf" style={{ display: "none" }} />
                    <VscCloudUpload style={{ fontSize: 48, color: "#6EBE44", marginBottom: 16 }} />
                    <Typography variant="h6" color="#25419eff" sx={{ fontWeight: 600 }}>
                      Upload a PDF to start editing
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Click or drag & drop PDF file here (Max 10MB)
                    </Typography>
                  </Box>
                )}

                {/* ======================== Dynamic Fields (Formulas, Radios, Labels) ======================== */}
                <Grid container mt={2}>
                  {fieldData?.map((fields, i) => (
                    <Box key={i}>
                      {/* Formula Fields */}
                      {fields?.formula?.length > 0 &&
                        fields.formula.map((formula, idx) => (
                          <Box
                            key={`formula-${idx}`}
                            mb={2}
                            p={2}
                            border={1}
                            borderRadius={1}
                            borderColor="divider"
                          >
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={11}>
                                <TextField
                                  fullWidth
                                  label="Formula"
                                  value={formula.expression || ""}
                                  onChange={(e) => {
                                    const newFields = [...fieldData];
                                    newFields[3].formula[idx].expression = e.target.value;
                                    setFieldData(newFields);
                                  }}
                                  placeholder="Enter formula (e.g., =A1+B1)"
                                />
                              </Grid>
                              <Grid item xs={1}>
                                <IconButton onClick={() => handleDelete("formula", idx)}>
                                  <CloseIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Box>
                        ))}

                      {/* Radio Buttons */}
                      {fields?.radio?.length > 0 &&
                        fields.radio.map((radio, radioIdx) => (
                          <Box
                            key={`radio-${radioIdx}`}
                            mb={2}
                            p={2}
                            border={1}
                            borderRadius={1}
                            borderColor="divider"
                          >
                            <Typography variant="subtitle2" gutterBottom>
                              {radio.fieldLabel || "Radio Group"}
                            </Typography>
                            <FormGroup>
                              {radio.value.map((option, optIdx) => (
                                <FormControlLabel
                                  key={`radio-option-${optIdx}`}
                                  control={
                                    <Radio
                                      checked={radio.selected === option}
                                      onChange={() => {
                                        const newFields = [...fieldData];
                                        newFields[5].radio[radioIdx].selected = option;
                                        setFieldData(newFields);
                                      }}
                                    />
                                  }
                                  label={option}
                                />
                              ))}
                            </FormGroup>
                            <IconButton
                              size="small"
                              onClick={() => handleDelete("radio", radioIdx)}
                              sx={{ mt: 1 }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        ))}
                    </Box>
                  ))}
                </Grid>

                {/* ======================== Label Fields ======================== */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                  {label1?.map((item, index) => (
                    <Grid item xs={12} display="flex" flexDirection="row" gap={2} key={index}>
                      <TextField
                        label={item}
                        variant="outlined"
                        fullWidth
                        disabled
                        margin="normal"
                        sx={{
                          "& .MuiOutlinedInput-input": { padding: 1.94 },
                        }}
                      />
                      <IconButton onClick={() => deleteInput({ name: "LABEL1", value: index })}>
                        -
                      </IconButton>
                    </Grid>
                  ))}

                  {label2?.map((item, index) => (
                    <Grid item xs={12} display="flex" flexDirection="row" gap={2} key={index}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label={item}
                          disabled
                          value={watch(item) ? dayjs(watch(item)) : null}
                          onChange={(date) => setValue(item, date?.toDate() || new Date())}
                          textField={(params) => <TextField {...params} fullWidth />}
                          sx={{
                            "& .MuiInputBase-input": { padding: 1.814 },
                          }}
                        />
                      </LocalizationProvider>
                      <IconButton onClick={() => deleteInput({ name: "LABEL2", value: index })}>
                        -
                      </IconButton>
                    </Grid>
                  ))}
                </Box>
              </Card>
            </Grid>


            {/* Setting Section */}
            <Grid item xs={12} sm={3} className="setting-section">
              <Card
                sx={{ padding: "2rem", display: "flex", borderRadius: "2px", minHeight: "80vh" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: "100%",
                  }}>
                  <Typography variant="h6" component="div" fontWeight="bold">
                    Settings
                  </Typography>
                  <Divider />
                  <TextField
                    label="Document Name"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    autoFocus={true}
                    // InputProps={{ style: { height: '50px' } }}
                    sx={{
                      "& .MuiOutlinedInput-input": {
                        padding: 1.94,
                      },
                      "& .MuiFormHelperText-root": {
                        marginLeft: 0,
                        marginTop: "4px",
                      },
                    }}
                    {...register("DOCUMENT_NAME")}
                    error={!!errors.DOCUMENT_NAME}
                    helperText={errors.DOCUMENT_NAME?.message}
                  />

                  <FormControl
                    fullWidth
                    sx={{ marginTop: -0.5 }}
                    error={!!errors.REQUIREMENT}>
                    <InputLabel id="requirement-select-label">
                      Requirement
                    </InputLabel>
                    <Controller
                      name="REQUIREMENT"
                      control={control}
                      render={({ field }) => (
                        <Select
                          autoFocus
                          labelId="requirement-select-label"
                          id="requirement-select"
                          label="Requirement"
                          {...field}
                          error={!!errors.REQUIREMENT}>
                          <MenuItem value="mandatory">Mandatory</MenuItem>
                          <MenuItem value="optional">Optional</MenuItem>
                        </Select>
                      )}
                    />
                    {errors.REQUIREMENT && (
                      <FormHelperText>
                        {errors.REQUIREMENT?.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    fullWidth
                    sx={{ marginTop: 1 }}
                    error={!!errors.DOCUMENT_STATUS}>
                    <InputLabel id="status-select-label">Status</InputLabel>
                    <Controller
                      name="DOCUMENT_STATUS"
                      control={control}
                      render={({ field }) => (
                        <Select
                          autoFocus
                          labelId="status-select-label"
                          id="status-select"
                          label="Status"
                          {...field}
                          error={!!errors.DOCUMENT_STATUS}>
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                      )}
                    />
                    {errors.DOCUMENT_STATUS && (
                      <FormHelperText>
                        {errors.DOCUMENT_STATUS?.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    fullWidth
                    margin="normal"
                    style={{ marginTop: -0.5 }}>
                    <Controller
                      name="JOBROLE_ID"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          select
                          label="Job Role"
                          value={field.value || ""}
                          onChange={(e) => {
                            field.onChange(e);        // updates react-hook-form state
                            handleRoleChange(e);      // your custom logic
                          }}

                          disabled={checked === true}
                          error={!!jobRoleMessage}
                          helperText={jobRoleMessage}>
                          <MenuItem disabled value="">
                            Select
                          </MenuItem>
                          {fetchJobRole?.map((role) => (
                            <MenuItem key={role?.ID} value={role?.ID}>
                              {role?.ROLE_NAME}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    />
                    <Box sx={{ mt: 2 }}>
                      <Grid container spacing={1}>
                        {selectedRoles?.map(
                          (jobRoleID) => (
                            (
                              <Grid item xs={12} key={jobRoleID}>
                                <Chip
                                  label={
                                    roles.find((role) => role.ID === jobRoleID)?.ROLE_NAME
                                  }
                                  onDelete={() => handleChipDelete(jobRoleID)}
                                  sx={{ borderRadius: 0.9 }}
                                />
                              </Grid>
                            )
                          )
                        )}
                      </Grid>
                    </Box>

                  </FormControl>

                  <Box
                    mt={0.2}
                    sx={{ display: "flex", alignItems: "center" }}
                    disabled>
                    <Controller
                      name="IS_ALL_JOBROLE"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          checked={field.value || false} // Use field.value instead of checked state
                          onChange={(e) => {
                            const newValue = e.target.checked;
                            field.onChange(newValue); // Update the form field
                            setChecked(newValue); // Update local state
                            setJobRoleMessage("");

                            if (newValue) {
                              setSelectedRoles([]);
                              setValue("JOBROLE_ID", [], { shouldValidate: true });
                              clearErrors("JOBROLE_ID");
                            }
                          }}
                          sx={{
                            "&.Mui-checked": {
                              color: "#6ebe44",
                            },
                            "&:focus": {
                              outline: "none",
                            },
                          }}
                        />
                      )}
                    />
                    <Typography
                      pt={-1}
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#000000",
                        opacity: "60%",
                      }}>
                      Set for all job types
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 2,
                      alignItems: "bottom",
                    }}>
                    <Button
                      variant="outlined"
                      sx={{ width: "90px", color: "#6ebe44" }}
                      onClick={() =>
                        navigate("/admin/profile-criteria/OnBoardingDocuments")
                      }>
                      Cancel
                    </Button>
                    <Button
                      className="gradientAdminThemeColor"
                      type="submit">
                      Save
                    </Button>
                  </Box>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </form>
      </Grid>

      {/* PdfEditorAdmin is now embedded in the center section */}
    </Grid>
  );
};

export default memo(AddOnBoardingDocuments2);